<template>
    <div ref="webviewContent" id="webview-external-wrapper" class="webview-external" v-loading="loading">
        <iframe src="" frameborder="0" id="externalframe"></iframe>
        <div ref='asideNav' id='aside-nav' class="aside-nav" :class="[activeName,menuActive]" v-if="!customize.hideToolbox">
            <div ref='dragDom' class="aside-menu">
                <div class='circle3'>&nbsp;</div>
                <div class='circle2'>&nbsp;</div>
                <div class='circle1'>&nbsp;</div>
                <div class='center'></div>
            </div>
            <a href="javascript:void(0)" title="返回首页" class="menu-item menu-first" @click="goback()">首页</a>
            <a href="javascript:void(0)" title="左上角" class="menu-item menu-second" @click="toLeftTop">左上</a>
            <a href="javascript:void(0)" title="左下角" class="menu-item menu-third" @click="toLeftBottom">左下</a>
            <a href="javascript:void(0)" title="关闭" class="menu-item menu-fourth" @click="close">关闭</a>
            <a href="javascript:void(0)" title="右下角" class="menu-item menu-fifth" @click="toRightBottom">右下</a>
            <a href="javascript:void(0)" title="右上角" class="menu-item menu-sixth" @click="toRightTop">右上</a>
        </div>
    </div>
</template>
<script>
  import {mapState} from 'vuex';
  import {postMessage} from '../../../../utils/event-bus';
  import Constants from '../../../../utils/constants';

  export default {
    data() {
      return {
        loading: false,
        iframeUrl: '',
        positionX: 0,
        positionY: 0,
        menuActive: '',
        direction: false,
        activeName: 'right-bottom'
      };
    },
    props: {
      customize: {
        type: Object,
        default(){
          return {};
        }
      }
    },
    computed: {
      ...mapState({
        webview: state => state.kiaf.webview
      })
    },
    watch: {
      'webview.external': function(){
        this.$nextTick(() => {
          this.dargAsideNav();
        });
      },
      'webview.url': function(){
        console.log('external webview.url>>>>>>>>>>>>>' + this.webview.url);
        if(this.iframeUrl != this.webview.url && this.webview.external){
          let webviewId = this.webview.id;
          let webviewUrl = this.webview.url;
          let webviewSign = this.webview.sign;
          let child = document.getElementById('externalframe');
          if(child){
            document.getElementById('webview-external-wrapper').removeChild(child);
          }
          let externalframe = document.createElement('iframe');
          externalframe.setAttribute('src', this.webview.url);
          externalframe.setAttribute('frameborder', 0);
          externalframe.setAttribute('id', 'externalframe');
          externalframe.setAttribute('width', '100%');
          externalframe.setAttribute('height', '100%');
          externalframe.setAttribute('margin', '0px');
          externalframe.setAttribute('padding', '0px');
          externalframe.setAttribute('allowfullscreen', true);
          externalframe.setAttribute('allow', 'geolocation; microphone; camera; midi; encrypted-media;');
          document.getElementById('webview-external-wrapper').appendChild(externalframe);
          this.loading = true;
          console.log('external webview externalframe.src>>>>>>>>>>>>>' + externalframe.src);
          externalframe.onload = () => {
            this.loading = false;
            postMessage(Constants.EVENT_BUS_CODE_WEBVIEW_ONLOAD, {id: webviewId, sign: webviewSign, url: webviewUrl});
          };
          let maxLoading = this.customize.maxLoading || 3000;
          setTimeout(() => {
            this.loading = false;
          }, maxLoading);
        }
      }

    },
    mounted(){
      if(this.webview.external){
        this.$nextTick(() => {
          this.dargAsideNav();
        });
      }
    },
    methods: {
       addEvent(eventName, element, fn){
        if (element.attachEvent) element.attachEvent('on' + eventName, fn);
        else element.addEventListener(eventName, fn, false);
      },
      goback() {
        this.$store.commit('KIAF_INIT_WEBVIEW', {});
        postMessage(Constants.EVENT_BUS_CODE_CLOSE_EXTERNAL_WEBVIEW, {});
      },
      close() {
        this.menuActive = '';
      },
      toLeftTop() {
        this.$refs.asideNav.removeAttribute('style');
        this.activeName = 'left-top';
        this.menuActive = '';
      },
      toLeftBottom() {
        this.$refs.asideNav.removeAttribute('style');
        this.activeName = 'left-bottom';
        this.menuActive = '';
      },
      toRightBottom() {
        this.$refs.asideNav.removeAttribute('style');
        this.activeName = 'right-bottom';
        this.menuActive = '';
      },
      toRightTop() {
        this.$refs.asideNav.removeAttribute('style');
        this.activeName = 'right-top';
        this.menuActive = '';
      },
      dargAsideNav(){ //添加拖动圆点事件
        let box = this.$refs.asideNav;
        let dragDom = this.$refs.dragDom;
        let webviewContent = this.$refs.webviewContent;
        if (!box || !dragDom) {
          return;
        }
        let that = this;
        box.onmousedown = function(ev) {
          let oEvent = ev || event;
          let x = oEvent.clientX - box.offsetLeft;
          let y = oEvent.clientY - box.offsetTop;
          let prevX = oEvent.clientX;
          let prevY = oEvent.clientY;
          console.log('onmousedown>>>x=' + oEvent.clientX + ', y =' + oEvent.clientY);
          webviewContent.onmousemove = function(ev) {
            if (ev.which != 1) { // 移动过程中，判断是否鼠标按下了左键
              return;
            }
            let oEvent = ev || event;
            //不能被拖出的浏览器窗口的范围
            let l = oEvent.clientX - x;
            let t = oEvent.clientY - y;
            if(l < 0) {
              l = 10;
            } else if(l > document.documentElement.clientWidth - box.offsetWidth) {
              l = document.documentElement.clientWidth - box.offsetWidth;
            }
            if(t < 0) {
              t = 10;
            } else if(t > document.documentElement.clientHeight - box.offsetHeight) {
              t = document.documentElement.clientHeight - box.offsetHeight;
            }
            console.log('onmousemove>>>l=' + l + ', t =' + t + 'oEvent.clientX=' + oEvent.clientX + 'oEvent.clientY=' + oEvent.clientY + 'which=' + ev.which);
            box.style.left = l + 'px';
            box.style.top = t + 'px';
          };
          webviewContent.onmouseup = function(ev) {
            let nowX = ev.clientX;
            let nowY = ev.clientY;
            console.log('onmouseup>>>nowX=' + nowX + ', nowY =' + nowY + ', prevX =' + prevX + ', prevY =' + prevY);
            webviewContent.onmousemove = null;
            webviewContent.onmouseup = null;
            if(Math.abs(nowX - prevX) <= 2 && Math.abs(nowY - prevY) <= 2){ //点击
              if(that.menuActive === 'active'){
                that.menuActive = '';
              } else {
                that.menuActive = 'active';
              }
            }
          };
          //阻止默认事件
          return false;
        };
      }
    }
  };
</script>
<style scoped>
    .webview-external {
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;
        margin:0px;
        padding: 0px;
    }

    iframe {
        width: 100%;
        height: 100%;
        margin:0px;
        padding: 0px;
    }

    .aside-nav {
        position: absolute;
        width: 160px;
        height: 160px;
        border-radius: 50%;
        background: transparent;
        opacity: 0.75;
    }

    .aside-nav .aside-menu {
        display: block;
        position: absolute;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
        line-height: 50px;
        color: #000;
        font-size: 20px;
        z-index: 1;
        cursor: pointer;
    }

    .aside-nav .menu-item {
        position: absolute;
        width: 46px;
        height: 46px;
        background-color: #304156;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        line-height: 46px;
        text-align: center;
        border-radius: 50%;
        text-decoration: none;
        color: #fff;
        transition: background .5s, transform .6s;
        font-size: 12px;
        box-sizing: border-box
    }

    .aside-nav .menu-item:hover {
        background: #304156;
        color: #fff;
    }

    .aside-nav.active {
        position: absolute;
        width: 160px;
        height: 160px;
        border-radius: 20px;
        opacity: 1
    }

    .aside-nav.active .menu-first {
        transform: translate3d(0, -135%, 0);
    }

    .aside-nav.active .menu-second {
        transform: translate3d(-120%, -70%, 0)
    }

    .aside-nav.active .menu-third {
        transform: translate3d(-120%, 70%, 0)
    }

    .aside-nav.active .menu-fourth {
        transform: translate3d(0, 135%, 0)
    }

    .aside-nav.active .menu-fifth {
        transform: translate3d(120%, 70%, 0)
    }

    .aside-nav.active .menu-sixth {
        transform: translate3d(120%, -70%, 0)
    }

    .right-top, .right-top.active {
        right: 10px;
        top: 10px;
    }

    .left-top, .left-top.active {
        left: 10px;
        top: 10px;
    }

    .left-bottom, .left-bottom.active {
        left: 10px;
        bottom: 10px;
    }

    .right-bottom, .right-bottom.active {
        right: 10px;
        bottom: 10px;
    }

    .circle1, .circle2, .circle3, .center {
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
    }

    .circle1 {
        margin: -16px 0 0 -16px;
        width: 32px;
        height: 32px;
        background-color: #92A9AC;
    }

    .circle2 {
        margin: -18px 0 0 -18px;
        width: 36px;
        height: 36px;
        background-color: #588683;
    }

    .circle3 {
        margin: -24px 0 0 -24px;
        width: 48px;
        height: 48px;
        background-color: #214F52;
    }

    .center {
        margin: -12px 0 0 -12px;
        width: 24px;
        height: 24px;
        background: #fff;
    }
</style>
